import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { nullSafeGet, getCurrency } from '../../utils/DataAccessUtils';

const ToolInfoHeader: FC<{ tool: any }> = ({ tool }) => {
	const currentUser = useSelector((state: any) => state.session.currentUser);
	const currency = useMemo(() => getCurrency({ currentUser }), [currentUser]);
	const currencyId = nullSafeGet('id', currency) || 'USD';

	return (
		<div className="border-teal-6 mb-6 border-l-4 bg-grey-3 py-2 pl-4">
			<div className="bodymedium text-character-primary">{nullSafeGet('name', tool)}</div>
			<div className="footnoteregular text-character-secondary">
				{nullSafeGet('stockLocation.name', tool)} · {nullSafeGet('costPerUse', tool)} {currencyId}
				/use
			</div>
		</div>
	);
};

export default ToolInfoHeader;
